<div [ngSwitch]="receivedObject.input_id" [style.height]="receivedObject.input_id === 6 || receivedObject.input_id === 7 ? '100%' : null">
    <!-- Cities (custcard-editpersonal) -->
    <div *ngSwitchCase="1" class="card__city">
        <div class="card-city__header" [ngClass]="{ 'card-city__header_new-city': isAddingNewElement }">
            <div class="input-wrapper input-wrapper_high card-city__search">
                <input class="input input_with-shadow" [(ngModel)]="cityFilterValue" type="search" placeholder="חפש" autocomplete="off" />
            </div>
            <button class="button button_theme_main-line button_with-icon card-city__button" (click)="toggleAddingNewElement()">
                <span class="button__plus-icon fa-regular fa-plus"></span>
                <span class="button__text">חדש</span>
            </button>

            <div class="card-city__new-city">
                <input
                    class="new-city__input"
                    #addNewCityInput
                    [(ngModel)]="newElementValue"
                    type="text"
                    placeholder="תן שם לישוב החדש"
                    autocomplete="off"
                />

                <div class="new-city__buttons">
                    <button class="button button_type_underline button_theme_secondary-line new-city__button" (click)="toggleAddingNewElement()">
                        בטל
                    </button>
                    <button class="button button_type_underline button_theme_main-line new-city__button" (click)="saveNewElement()">שמור</button>
                </div>
            </div>
        </div>

        <div class="card-city__table-wrapper custom-scrollbar">
            <p-table
                *ngIf="!isCitiesEmpty() && !isCitiesNoResults()"
                class="card-city__table table"
                [value]="getCitiesValue()"
                dataKey="cityId"
                [(selection)]="selectedCity"
                selectionMode="single"
                editMode="row"
            >
                <ng-template pTemplate="body" let-city let-editing="editing" let-ri="rowIndex">
                    <tr class="table__row" #row [pEditableRow]="city">
                        <td class="table__column column-remove">
                            <button class="column-remove__button fa-regular fa-trash-can" (click)="removeElement(city)"></button>
                        </td>

                        <td *ngIf="!editing" class="table__column column-edit">
                            <button class="column-edit__button fa-regular fa-pen" pInitEditableRow (click)="onRowEditInit(city, row)"></button>
                        </td>

                        <td *ngIf="!editing" class="table__column column-editable">
                            <p-cellEditor>
                                <ng-template pTemplate="output">
                                    {{ city.cityName }}
                                </ng-template>
                            </p-cellEditor>
                        </td>

                        <td *ngIf="editing" class="table__column column-edit_state_editing" colspan="2">
                            <div class="column-edit__wrapper">
                                <div class="column-edit__buttons">
                                    <button
                                        class="button button_type_underline button_theme_main-line"
                                        pSaveEditableRow
                                        (click)="onRowEditSave(city)"
                                    >
                                        שמור
                                    </button>

                                    <button
                                        class="button button_type_underline button_theme_secondary-line"
                                        pCancelEditableRow
                                        (click)="onRowEditCancel(city, ri)"
                                    >
                                        בטל
                                    </button>
                                </div>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input class="column-editable__input" pInputText [(ngModel)]="city.cityName" type="text" required />
                                    </ng-template>
                                </p-cellEditor>
                            </div>
                        </td>

                        <td class="table__column column-radio">
                            <p-tableRadioButton class="column-radio__button" [value]="city"></p-tableRadioButton>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <div *ngIf="isCitiesNoResults()" class="card-city__error card-city__no-results">
                <span class="error__header">לא נמצאו תוצאות</span>
                <span class="error__text">נסה שוב</span>
                <img src="/assets/img/no-cities-results.svg" />
            </div>
            <div *ngIf="isCitiesEmpty()" class="card-city__error card-city__empty">
                <span class="error__header">אין ערים להציג</span>
                <span class="error__text">לחץ על כפתור ״חדש״ כדי להוסיף עיר או ישוב</span>
                <img src="/assets/img/no-cities.svg" />
            </div>
        </div>
    </div>

    <!-- Categories (custcard-editpersonal) -->
    <div *ngSwitchCase="2" class="card__category">
        <div class="card-category__header" [ngClass]="{ 'card-category__header_new-category': isAddingNewElement }">
            <button class="button button_theme_main-line button_with-icon card-category__button" (click)="toggleAddingNewElement()">
                <span class="button__plus-icon fa-regular fa-plus"></span>
                <span class="button__text">חדש</span>
            </button>

            <div class="card-category__new-category">
                <input
                    class="new-category__input"
                    #addNewCategoryInput
                    [(ngModel)]="newElementValue"
                    type="text"
                    placeholder="תן שם לתיוג החדש"
                    autocomplete="off"
                />

                <div class="new-category__buttons">
                    <button class="button button_type_underline button_theme_secondary-line new-category__button" (click)="toggleAddingNewElement()">
                        בטל
                    </button>
                    <button class="button button_type_underline button_theme_main-line new-category__button" (click)="saveNewElement()">שמור</button>
                </div>
            </div>
        </div>

        <div class="card-category__table-wrapper custom-scrollbar">
            <p-table
                class="card-category__table table"
                [value]="categories"
                dataKey="custCategoryId"
                [(selection)]="selectedCategories"
                selectionMode="multiple"
                editMode="row"
                [reorderableColumns]="true"
            >
                <ng-template pTemplate="body" let-category let-editing="editing" let-ri="rowIndex" let-index="rowIndex">
                    <tr class="table__row" #row [pEditableRow]="category" [pReorderableRow]="index">
                        <td class="table__column column-remove">
                            <button class="column-remove__button fa-regular fa-trash-can" (click)="removeElement(category)"></button>
                        </td>

                        <td *ngIf="!editing" class="table__column column-edit">
                            <button class="column-edit__button fa-regular fa-pen" pInitEditableRow (click)="onRowEditInit(category, row)"></button>
                        </td>

                        <td *ngIf="!editing" class="table__column column-editable">
                            <p-cellEditor>
                                <ng-template pTemplate="output">
                                    {{ category.custCategoryName }}
                                </ng-template>
                            </p-cellEditor>
                        </td>

                        <td *ngIf="editing" class="table__column column-edit_state_editing" colspan="2">
                            <div class="column-edit__wrapper">
                                <div class="column-edit__buttons">
                                    <button
                                        class="button button_type_underline button_theme_main-line"
                                        pSaveEditableRow
                                        (click)="onRowEditSave(category)"
                                    >
                                        שמור
                                    </button>

                                    <button
                                        class="button button_type_underline button_theme_secondary-line"
                                        pCancelEditableRow
                                        (click)="onRowEditCancel(category, ri)"
                                    >
                                        בטל
                                    </button>
                                </div>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input
                                            class="column-editable__input"
                                            pInputText
                                            [(ngModel)]="category.custCategoryName"
                                            type="text"
                                            required
                                        />
                                    </ng-template>
                                </p-cellEditor>
                            </div>
                        </td>

                        <td class="table__column column-checkbox">
                            <p-tableCheckbox class="column-checkbox__button" [value]="category"></p-tableCheckbox>
                        </td>

                        <td class="table__column column-reorder">
                            <i class="column-reorder__icon fa-solid fa-grip-dots-vertical" pReorderableRowHandle></i>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <!-- Recommenders (custcard-editpersonal) -->
    <div *ngSwitchCase="3" class="card__recommender">
        <div class="card-recommender__header">
            <div class="input-wrapper input-wrapper_high card-recommender__search">
                <input
                    class="input input_with-shadow"
                    type="search"
                    placeholder="חפש"
                    autocomplete="off"
                    [(ngModel)]="recommenderInput"
                    (keyup.enter)="searchRecommender()"
                />
            </div>

            <button class="button button_theme_main-line card-recommender__button" (click)="searchRecommender()">
                <span class="button__text">חפש</span>
            </button>
        </div>

        <div class="card-recommender__table-wrapper custom-scrollbar">
            <p-table
                #recommendersTable
                class="card-recommender__table table"
                [ngClass]="{ 'card-recommender__table_hidden': recommendersState != 'loaded' && recommendersState != 'pinned' }"
                [value]="recommenders"
                dataKey="recommenderId"
                [(selection)]="selectedRecommender"
                selectionMode="single"
                [paginator]="true"
                [rows]="50"
                [alwaysShowPaginator]="false"
                (onPage)="onRecommendersPageChange()"
                [lazy]="true"
                [totalRecords]="recommendersTotalRecords"
                (onLazyLoad)="lazyLoadRecommenders($event)"
            >
                <ng-template pTemplate="body" let-recommender let-ri="rowIndex" let-index="rowIndex">
                    <tr class="table__row" #row>
                        <td class="table__column" colspan="2">
                            <span>{{ recommender.recommenderName }}</span>
                        </td>

                        <td class="table__column column-checkbox">
                            <p-tableRadioButton class="column-checkbox__button" [value]="recommender"></p-tableRadioButton>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <div *ngIf="recommendersState == 'empty'" class="card-recommender__error card-recommender__empty">
                <span>אנא הזן 2 תווים לפחות משם הלקוח</span>
                <span>או מספר הטלפון</span>
            </div>

            <div *ngIf="recommendersState == 'pinned'" class="card-recommender__error card-recommender__pinned">
                <span>אם ברצונך לנקות ולהשאר ללא לקוח ממליץ,</span>
                <span>ניתן ללחוץ על ״בטל בחירה״ ולשמור.</span>
            </div>

            <div *ngIf="recommendersState == 'noresults'" class="card-recommender__error card-recommender__no-results">
                <span>לא נמצאו תוצאות אנא נסה שנית</span>
                <img src="/assets/img/no-recommenders-results.png" />
            </div>

            <div *ngIf="recommendersState == 'loading'" class="card-recommender__error card-recommender__no-results">
                <span>טוען מאגר לקוחות...</span>
                <span class="card-recommender__loader"></span>
            </div>
        </div>
    </div>

    <!-- Sources (custcard-editpersonal) -->
    <div *ngSwitchCase="4" class="card__source">
        <div class="card-source__header" [ngClass]="{ 'card-source__header_new-source': isAddingNewElement }">
            <div class="input-wrapper input-wrapper_high card-source__search">
                <input class="input input_with-shadow" [(ngModel)]="sourceFilterValue" type="search" placeholder="חפש" autocomplete="off" />
            </div>
            <button class="button button_theme_main-line button_with-icon card-source__button" (click)="toggleAddingNewElement()">
                <span class="button__plus-icon fa-regular fa-plus"></span>
                <span class="button__text">חדש</span>
            </button>

            <div class="card-source__new-source">
                <input
                    class="new-source__input"
                    #addNewSourceInput
                    [(ngModel)]="newElementValue"
                    type="text"
                    placeholder="תן שם למקור הגעה החדש"
                    autocomplete="off"
                />

                <div class="new-source__buttons">
                    <button class="button button_type_underline button_theme_secondary-line new-source__button" (click)="toggleAddingNewElement()">
                        בטל
                    </button>
                    <button class="button button_type_underline button_theme_main-line new-source__button" (click)="saveNewElement()">שמור</button>
                </div>
            </div>
        </div>

        <div class="card-source__table-wrapper custom-scrollbar">
            <p-table
                class="card-source__table table"
                [value]="getSourcesValue()"
                dataKey="sourceId"
                [(selection)]="selectedSource"
                selectionMode="single"
                editMode="row"
                [reorderableColumns]="true"
                (onRowReorder)="onSourceRowReorder($event)"
            >
                <ng-template pTemplate="body" let-source let-editing="editing" let-ri="rowIndex" let-index="rowIndex">
                    <tr class="table__row" #row [pEditableRow]="source" [pReorderableRow]="index">
                        <td class="table__column column-remove">
                            <button class="column-remove__button fa-regular fa-trash-can" (click)="removeElement(source)"></button>
                        </td>

                        <td *ngIf="!editing" class="table__column column-edit">
                            <button class="column-edit__button fa-regular fa-pen" pInitEditableRow (click)="onRowEditInit(source, row)"></button>
                        </td>

                        <td *ngIf="!editing" class="table__column column-editable">
                            <p-cellEditor>
                                <ng-template pTemplate="output">
                                    {{ source.sourceName }}
                                </ng-template>
                            </p-cellEditor>
                        </td>

                        <td *ngIf="editing" class="table__column column-edit_state_editing" colspan="2">
                            <div class="column-edit__wrapper">
                                <div class="column-edit__buttons">
                                    <button
                                        class="button button_type_underline button_theme_main-line"
                                        pSaveEditableRow
                                        (click)="onRowEditSave(source)"
                                    >
                                        שמור
                                    </button>

                                    <button
                                        class="button button_type_underline button_theme_secondary-line"
                                        pCancelEditableRow
                                        (click)="onRowEditCancel(source, ri)"
                                    >
                                        בטל
                                    </button>
                                </div>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input class="column-editable__input" pInputText [(ngModel)]="source.sourceName" type="text" required />
                                    </ng-template>
                                </p-cellEditor>
                            </div>
                        </td>

                        <td class="table__column column-radio">
                            <p-tableRadioButton class="column-radio__button" [value]="source"></p-tableRadioButton>
                        </td>

                        <td class="table__column column-reorder">
                            <i class="column-reorder__icon fa-solid fa-grip-dots-vertical" pReorderableRowHandle></i>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <!-- Occupations (custcard-editpersonal) -->
    <div *ngSwitchCase="5" class="card__occupation">
        <div class="card-occupation__header" [ngClass]="{ 'card-occupation__header_new-occupation': isAddingNewElement }">
            <div class="input-wrapper input-wrapper_high card-occupation__search">
                <input class="input input_with-shadow" [(ngModel)]="occupationFilterValue" type="search" placeholder="חפש" autocomplete="off" />
            </div>
            <button class="button button_theme_main-line button_with-icon card-occupation__button" (click)="toggleAddingNewElement()">
                <span class="button__plus-icon fa-regular fa-plus"></span>
                <span class="button__text">חדש</span>
            </button>

            <div class="card-occupation__new-occupation">
                <input
                    class="new-occupation__input"
                    #addNewOccupationInput
                    [(ngModel)]="newElementValue"
                    type="text"
                    placeholder="תן שם לתחום עיסוק החדש"
                    autocomplete="off"
                />

                <div class="new-occupation__buttons">
                    <button
                        class="button button_type_underline button_theme_secondary-line new-occupation__button"
                        (click)="toggleAddingNewElement()"
                    >
                        בטל
                    </button>
                    <button class="button button_type_underline button_theme_main-line new-occupation__button" (click)="saveNewElement()">
                        שמור
                    </button>
                </div>
            </div>
        </div>

        <div class="card-occupation__table-wrapper custom-scrollbar">
            <p-table
                class="card-occupation__table table"
                [value]="getOccupationsValue()"
                dataKey="occupationId"
                [(selection)]="selectedOccupation"
                selectionMode="single"
                editMode="row"
            >
                <ng-template pTemplate="body" let-occupation let-editing="editing" let-ri="rowIndex" let-index="rowIndex">
                    <tr class="table__row" #row [pEditableRow]="occupation" [pReorderableRow]="index">
                        <td class="table__column column-remove">
                            <button class="column-remove__button fa-regular fa-trash-can" (click)="removeElement(occupation)"></button>
                        </td>

                        <td *ngIf="!editing" class="table__column column-edit">
                            <button class="column-edit__button fa-regular fa-pen" pInitEditableRow (click)="onRowEditInit(occupation, row)"></button>
                        </td>

                        <td *ngIf="!editing" class="table__column column-editable">
                            <p-cellEditor>
                                <ng-template pTemplate="output">
                                    {{ occupation.occupationName }}
                                </ng-template>
                            </p-cellEditor>
                        </td>

                        <td *ngIf="editing" class="table__column column-edit_state_editing" colspan="2">
                            <div class="column-edit__wrapper">
                                <div class="column-edit__buttons">
                                    <button
                                        class="button button_type_underline button_theme_main-line"
                                        pSaveEditableRow
                                        (click)="onRowEditSave(occupation)"
                                    >
                                        שמור
                                    </button>

                                    <button
                                        class="button button_type_underline button_theme_secondary-line"
                                        pCancelEditableRow
                                        (click)="onRowEditCancel(occupation, ri)"
                                    >
                                        בטל
                                    </button>
                                </div>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input
                                            class="column-editable__input"
                                            pInputText
                                            [(ngModel)]="occupation.occupationName"
                                            type="text"
                                            required
                                        />
                                    </ng-template>
                                </p-cellEditor>
                            </div>
                        </td>

                        <td class="table__column column-radio">
                            <p-tableRadioButton class="column-radio__button" [value]="occupation"></p-tableRadioButton>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <!-- Proposal comment edit (custcardview45) -->
    <div *ngSwitchCase="6" class="card__proposal">
        <div class="card-proposal__header">
            <button class="header__close" (click)="closeModal()">
                <i class="fa-regular fa-xmark"></i>
            </button>

            <div class="header__title">
                <h1 class="header__text">נוסף ב: {{ proposal.dateProposal }}</h1>
                <i class="fa-light fa-clock-nine"></i>
            </div>

            <button class="header__button_mobile" (click)="toggleSubMenu($event, menu, true)">
                <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>
            <button class="header__button" (click)="toggleSubMenu($event, menu, false)">
                <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>
            <p-menu #menu class="header__menu action-list" [model]="proposalMenu" [popup]="true"></p-menu>
        </div>

        <div class="card-proposal__content">
            <img *ngIf="proposal.isImage" class="content__attachment_type_image" [src]="proposalURL" />
            <span *ngIf="proposal.isVideo" class="content__attachment_type_video"></span>
            <span *ngIf="!proposal.isImage && !proposal.isVideo" class="content__attachment_type_document"></span>
        </div>

        <!-- <div class="card-proposal__footer"> -->
        <div class="card-proposal__footer" [ngClass]="{ 'card-proposal__footer_collapsed': isProposalCommentCollapsed }">
            <button class="accordion__header" (click)="isProposalCommentCollapsed = !isProposalCommentCollapsed">
                <i class="accordion__icon fa-solid fa-angle-left"></i>
                <span class="accordion__line"></span>
                <span class="accordion__main-text">הערות </span>
                <span class="accordion__additional-text">(צפייה ועריכה)</span>
            </button>

            <div class="accordion__content">
                <textarea #proposalTextarea class="card-proposal__comment" [(ngModel)]="proposalComment" maxlength="150"></textarea>
                <div class="modal__footer-buttons">
                    <button class="button button_size_small button_theme_main" (click)="saveData()">שמירה</button>
                    <button class="button button_size_small button_theme_gray-line" (click)="closeModal()">ביטול</button>
                </div>
            </div>
        </div>

        <div *ngIf="isProposalMenuOpened || isProposalConfirmDialogVisible" class="modal-background"></div>

        <p-dialog
            [ngClass]="{ 'custom-dialog': isProposalMenuOpened }"
            styleClass="modal modal_type_menu modal_proposal-menu"
            [(visible)]="isProposalMenuOpened"
            header="פעולות נוספות"
            [modal]="true"
            [resizable]="false"
            [draggable]="false"
            transitionOptions="0ms"
        >
            <button
                *ngFor="let item of proposalMenu"
                class="menu-button {{ item.icon }} button button_with-icon"
                (click)="item.command()"
                [disabled]="item.disabled"
            >
                {{ item.label }}
            </button>
        </p-dialog>

        <p-dialog
            [ngClass]="{ 'custom-dialog': isProposalConfirmDialogVisible }"
            styleClass="modal modal_type_confirm"
            [(visible)]="isProposalConfirmDialogVisible"
            header="אזהרה"
            [modal]="true"
            [resizable]="false"
            [draggable]="false"
        >
            <div class="modal__text">האם אתם בטוחים שברצונכם למחוק את התמונה/הקובץ?</div>
            <div class="modal__footer">
                <button class="button button_size_small button_theme_main" (click)="closeProposalConfirmDialog(true)">מחיקה</button>
                <button class="button button_size_small button_theme_gray-line" (click)="closeProposalConfirmDialog(false)">ביטול</button>
            </div>
        </p-dialog>
    </div>

    <!-- Proposal upload (custcardview45) -->
    <div *ngSwitchCase="7" class="card__proposal-upload">
        <div class="card-proposal__header card-proposal-upload__header">
            <button class="header__close" [disabled]="isCloseProposalUploadingPopupDisabled()" (click)="closeModal()">
                <i class="fa-regular fa-xmark"></i>
            </button>

            <div class="header__title">
                <h1 class="header__text">העלאת קבצים</h1>
                <h2 class="header__info">ניתן להעלות מספר קבצים במקביל,ועד לגודל 15MG לכל קובץ</h2>
            </div>
        </div>

        <div class="card-proposal-upload__content custom-scrollbar">
            <p-table class="card-proposal-upload__table table" [value]="newFiles">
                <ng-template pTemplate="body" let-file>
                    <tr>
                        <td class="column-file-state">
                            <span *ngIf="file.isFileUploaded == 'uploading'" class="card-proposal-upload__loader"></span>

                            <span *ngIf="file.isFileUploaded == 'uploaded'" class="card-proposal-upload__success-icon">
                                <i class="fa-solid fa-circle-check"></i>
                            </span>

                            <span
                                *ngIf="file.isFileUploaded == 'sizeError' || file.isFileUploaded == 'uploadError'"
                                class="card-proposal-upload__error-icon"
                            >
                                <i class="fa-duotone fa-circle-exclamation"></i>
                            </span>
                        </td>

                        <td class="column-file-name">
                            <span
                                class="card-proposal-upload__file-name"
                                [ngClass]="{
                                    'card-proposal-upload__file-name_error':
                                        file.isFileUploaded == 'sizeError' || file.isFileUploaded == 'uploadError'
                                }"
                                >{{ file.name }}</span
                            >
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <!-- Chemistry services edit (custcardview42) -->
    <div *ngSwitchCase="8" class="card-chemistry-services">
        <div *ngIf="!isAddingOrEditingChemistryService" class="card-chemistry-services__header">
            <button class="button button_theme_main-line button_with-icon" (click)="toggleAddignNewChemistryService()">
                סוג חדש
                <i class="button__plus-icon fa-regular fa-plus"></i>
            </button>
        </div>

        <div *ngIf="isAddingOrEditingChemistryService" class="card-chemistry-services__header_edit-service">
            <div class="input-wrapper input-wrapper_high">
                <input
                    class="input input_with-shadow chemistry-service__input"
                    #chemistryServiceInput
                    [(ngModel)]="chemistryServiceName"
                    type="text"
                    placeholder="תנו שם לסוג הכימיה החדשה"
                    autocomplete="off"
                />
            </div>

            <p-carousel
                class="chemistry__carousel chemistry-service__carousel"
                [value]="chemistryServicesIcons"
                [numVisible]="chemistryCarouselLength"
                [numScroll]="1"
                [responsiveOptions]="responsiveChemistryCarousel"
                [circular]="true"
            >
                <ng-template let-icon pTemplate="item">
                    <button
                        class="carousel__item"
                        [ngClass]="{ carousel__item_active: chemistryServiceIcon == icon }"
                        (click)="selectChemistryIcon(icon)"
                    >
                        <img class="carousel__item-image" src="assets/img/{{ icon.serviceIconName }}" alt="{{ icon.serviceIconName }}" />
                    </button>
                </ng-template>
            </p-carousel>

            <div class="chemistry-service__buttons">
                <button class="button button_type_underline button_theme_main-line" (click)="saveChemistryService()">שמור</button>
                <button class="button button_type_underline button_theme_secondary-line" (click)="toggleAddignNewChemistryService()">בטל</button>
            </div>
        </div>

        <div
            class="card-chemistry-services__table-wrapper custom-scrollbar"
            [ngClass]="{ 'card-chemistry-services__table-wrapper_reduced': isAddingOrEditingChemistryService }"
        >
            <p-table class="table card-chemistry-services__table" [value]="chemistryServices" dataKey="serviceInd" [reorderableColumns]="true">
                <ng-template pTemplate="body" let-service let-index="rowIndex">
                    <tr class="table__row" #row [pReorderableRow]="index">
                        <td class="table__column column-remove">
                            <button class="column-remove__button fa-regular fa-trash-can" (click)="removeElement(service)"></button>
                        </td>

                        <td class="table__column column-edit">
                            <button class="column-edit__button fa-solid fa-pen-to-square" (click)="editChemistryService(service)"></button>
                        </td>

                        <td class="table__column column-text">
                            {{ service.serviceName }}
                        </td>

                        <td class="table__column column-icon">
                            <div class="table-chemistry__icon">
                                <img src="assets/img/{{ service.serviceIconName }}" />
                            </div>
                        </td>

                        <td class="table__column column-reorder">
                            <i class="column-reorder__icon fa-solid fa-grip-dots-vertical" pReorderableRowHandle></i>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <!-- Chemistry cardcolor edit (custcardview42) -->
    <div *ngSwitchCase="9" class="card-chemistry-edit">
        <h2 class="card-chemistry-edit__title">בחירת סוג כימיה</h2>
        <div class="card-chemistry-edit__body">
            <p-carousel
                class="chemistry__carousel chemistry-edit__carousel"
                [value]="chemistryServices"
                [numVisible]="chemistryServicesCarouselLength"
                [numScroll]="1"
                [responsiveOptions]="responsiveServicesChemistryCarousel"
                [circular]="true"
                [page]="chemistryCarouselPage"
            >
                <ng-template let-service pTemplate="item">
                    <button
                        class="carousel__item"
                        [ngClass]="{ carousel__item_active: selectedChemistryService == service }"
                        (click)="selectChemistryService(service)"
                    >
                        <img class="carousel__item-image" src="assets/img/{{ service.serviceIconName }}" alt="{{ service.serviceIconName }}" />
                        <span class="carousel__item-text">{{ service.serviceName }}</span>
                    </button>
                </ng-template>
            </p-carousel>

            <div
                class="chemistry__carousel-error-wrapper"
                [ngClass]="{ 'carousel-error-wrapper_visible': isChemistryServiceErrorVisible }"
                #chemistryCarouselError
            >
                <span *ngIf="isChemistryServiceErrorVisible" class="chemistry__carousel-error">* חובה לבחור סוג כימיה</span>
            </div>

            <span *ngIf="isChemistryServiceErrorVisible" class="chemistry__carousel-error chemistry__carousel-error_large">* חובה לבחור סוג כימיה</span>

            <div
                class="input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_datepicker"
                [ngClass]="{
                    'input-wrapper_error': isChemistryDateErrorVisible && regDateModel.invalid,
                    'input-wrapper_with-details': isChemistryDateErrorVisible && regDateModel.invalid
                }"
            >
                <span class="input-label">תאריך</span>
                <input
                    class="input"
                    bsDatepicker
                    [(appDateMask)]="cardColor.regDate"
                    [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', adaptivePosition: true, isAnimated: true }"
                    [maxDate]="maxDate"
                    [(ngModel)]="cardColor.regDate"
                    #regDateModel="ngModel"
                    type="text"
                    placeholder="בחר"
                    autocomplete="off"
                    required
                />
                <span *ngIf="isChemistryDateErrorVisible && regDateModel.invalid" class="input-details">* יש לבחור תאריך</span>
            </div>

            <div
                class="input-wrapper input-wrapper_with-label input-wrapper_type_textarea chemistry-edit__textarea-wrapper chemistry-edit__textarea-wrapper_large chemistry-edit__textarea-wrapper_first"
                [ngClass]="{ 'input-wrapper_disabled': isDisabled(79) }"
            >
                <span class="input-label">חברות / צבעים</span>
                <textarea
                    class="input"
                    [(ngModel)]="cardColor.companies"
                    placeholder="הוסף הערות..."
                    autocomplete="off"
                    [disabled]="isDisabled(79)"
                ></textarea>
            </div>

            <div
                class="input-wrapper input-wrapper_with-label input-wrapper_type_textarea chemistry-edit__textarea-wrapper chemistry-edit__textarea-wrapper_large"
                [ngClass]="{ 'input-wrapper_disabled': isDisabled(80) }"
            >
                <span class="input-label">חמצנים</span>
                <textarea
                    class="input"
                    [(ngModel)]="cardColor.oxyGen"
                    placeholder="הוסף הערות..."
                    autocomplete="off"
                    [disabled]="isDisabled(80)"
                ></textarea>
            </div>

            <div
                class="input-wrapper input-wrapper_with-label input-wrapper_type_textarea chemistry-edit__textarea-wrapper chemistry-edit__textarea-wrapper_small"
                [ngClass]="{ 'input-wrapper_disabled': isDisabled(81) }"
            >
                <span class="input-label">הנחיות/הערות/מחיר</span>
                <textarea
                    class="input"
                    [(ngModel)]="cardColor.comments"
                    placeholder="הוסף הערות..."
                    autocomplete="off"
                    [disabled]="isDisabled(81)"
                ></textarea>
            </div>

            <div
                class="input-wrapper input-wrapper_with-label input-wrapper_type_textarea chemistry-edit__textarea-wrapper chemistry-edit__textarea-wrapper_small"
                [ngClass]="{ 'input-wrapper_disabled': isDisabled(82) }"
            >
                <span class="input-label">זמן המתנה</span>
                <textarea
                    class="input"
                    [(ngModel)]="cardColor.description"
                    placeholder="הוסף הערות..."
                    autocomplete="off"
                    [disabled]="isDisabled(82)"
                ></textarea>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isFooterVisible" class="modal__footer">
    <div class="modal__footer-buttons">
        <button class="button button_size_small button_theme_main" [disabled]="isSubmitDisabled" (click)="saveData()">שמירה</button>
        <button class="button button_size_small button_theme_gray-line" (click)="closeModal()">ביטול</button>
    </div>
    <button *ngIf="isFooterClearVisible" class="button button_type_underline button_theme_black-line footer__clear-button" (click)="clearSelected()">
        בטל בחירה
    </button>
</div>

<p-messages class="messages"></p-messages>
